import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  SvgIcon,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Copy as CopyIcon,
} from '../../../../../components/Icons';
import {
  deleteAlgoStart,
  duplicateAlgoStart,
  renameAlgoStart,
} from '../../../../../stores/algos-list/actions';
import { getAlgoListDataCachedSelectedDay } from '../../../../../stores/algos-list/getters';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiTypography-body1': {
      fontSize: '0.9rem',
      fontWeight: 400,
    },

    '& .MuiListItemIcon-root': {
      minWidth: 40,
      color: 'var(--color-colorPrimary-main)',
    },

    '& .copy-icon': {
      '& path': {
        fill: 'var(--color-colorPrimary-main)',
      },
    },
  },
}));

const ActionMenu = ({ actionMenu = null, original = {}, onClose = {} }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { _id = '' } = original;

  const broker = useSelector((state) => {
    const { broker = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return broker;
  });

  const name = useSelector((state) => {
    const { name = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return name;
  });

  const day = useSelector((state) => {
    const { day = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return day;
  });

  const type = useSelector((state) => {
    const { type } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return type;
  });

  const onRename = () => {
    dispatch(renameAlgoStart(_id, name));
    onClose();
  };

  const onDelete = () => {
    dispatch(deleteAlgoStart(_id));
    onClose();
  };

  const onDuplicate = () => {
    dispatch(duplicateAlgoStart(_id, name, day, broker, type));
    onClose();
  };

  return (
    <Menu
      id="simple-menu"
      anchorEl={actionMenu}
      keepMounted
      open={Boolean(actionMenu)}
      onClose={onClose}
      className={classes.root}
    >
      <MenuItem onClick={onRename}>
        <ListItemIcon>
          <SvgIcon component={EditIcon} fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Rename" />
      </MenuItem>
      <MenuItem onClick={onDuplicate}>
        <ListItemIcon>
          <SvgIcon
            component={CopyIcon}
            fontSize="small"
            className="copy-icon"
          />
        </ListItemIcon>
        <ListItemText primary="Duplicate" />
      </MenuItem>
      <MenuItem onClick={onDelete}>
        <ListItemIcon>
          <SvgIcon component={DeleteIcon} fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Delete" />
      </MenuItem>
    </Menu>
  );
};

export default ActionMenu;
